<template>
  <div>
    <CommonTable
      list-getter="projectMeteringStore/meterUnitStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="meter-units"
      deleteItemDispatch="projectMeteringStore/meterUnitStore/delete"
      createItemDispatch="projectMeteringStore/meterUnitStore/create"
      @updated="updateList"
      :loading.sync="loading"
      :static-dispatch-params="{ project_id: $route.params.project_id }"
    ></CommonTable>
    <Paginator
      page-getter="projectMeteringStore/meterUnitStore/getPage"
    ></Paginator>
  </div>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
import Paginator from "../../../common/tables/Paginator";
export default {
  name: "UnitsMeter",
  components: {
    CommonTable,
    Paginator
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("meter-units.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("meter-units.source"),
          value: "source_name"
        }
      ],
      actions: [],
      slots: [
        {
          name: "name",
          type: "link",
          to: "meter-unit"
        },
        {
          name: "source_name",
          type: "link",
          to: "source",
          linkParams: {
            id: "source_id"
          }
        }
      ],
      loading: false
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      params.project_id = this.$route.params.project_id;
      params.filters = { meter: this.$route.params.id };
      this.$store.dispatch("projectMeteringStore/meterUnitStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders
      };
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped></style>
